export const modalityOptions = { 1: 'Membresía', 2: 'Suscripción' }

export const planOptions = { 1: 'Prueba', 2: 'Básico', 3: 'Pro', 4: 'Premium' }

export const invoiceStatuses = { 1: 'Pagada', 2: 'Cancelada', 3: 'Morosa', 4: 'Pendiente' }